import {JSX} from "react";
import {Navigate, Outlet, useLocation} from "react-router";
import {isProfileIncomplete} from "../functions";
import {usePermits} from "../hooks/usePermits";
import {useUser} from "../hooks/useUser";

import {PrivateRoutes, PublicRoutes} from "../routes";

export default function PrivateRoute(): JSX.Element {
	const user = useUser();
	const permits = usePermits();
	const location = useLocation();

	if (user.authStatus == "unauthorized") return <Navigate to={PublicRoutes.home}/>;

	if (isProfileIncomplete(permits.holder) && location.pathname != PrivateRoutes.completeProfile)
		return <Navigate to={PrivateRoutes.completeProfile} replace/>;

	return <Outlet/>;
}
